import {Controller} from "@hotwired/stimulus"
import {Modal} from "bootstrap"


export default class extends Controller {
    static values = {
        url: String,
    }



    toggle_menu(e) {
        // console.log(this.urlValue)
        fetch(this.urlValue, {
            headers: {
                Accept: "text/vnd.turbo-stream.html",
            },
        }).then(r => r.text())
            .then(html => Turbo.renderStreamMessage(html))

    }
}